import { render, staticRenderFns } from "./liveliveactive.vue?vue&type=template&id=7dc32c48&scoped=true"
import script from "./liveliveactive.vue?vue&type=script&lang=js"
export * from "./liveliveactive.vue?vue&type=script&lang=js"
import style0 from "./liveliveactive.vue?vue&type=style&index=0&id=7dc32c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc32c48",
  null
  
)

export default component.exports